import { createPortal } from "react-dom";

const MobileHeader = ({
  children,
  actions,
}: {
  children?: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
}) => {
  return createPortal(
    <header
      data-mobile-header
      data-empty={!children && !actions}
      className="fixed top-0 left-0 right-0 z-20 h-14 px-3 w-full flex justify-between items-center gap-2"
    >
      <div className="mobile-header-title min-w-0 flex items-center gap-2">
        {children}
      </div>
      <div className="mobile-header-actions flex shrink-0 items-center gap-1">
        {actions}
      </div>
    </header>,
    document.body,
  );
};

export default MobileHeader;
